const CategoriesEn = {
  'Description has been already registered':
    'Description has been already registered',
  'category is not a group':
    'Category is not a group'
};

export default CategoriesEn;
